import { PortalBacklogStatus, PortalLabelTone, PortalRoadmapKind, PortalRoadmapStatus } from './portalTypes';

export const backlogStatusLabel: Record<PortalBacklogStatus, string> = {
  idea: 'Ideia',
  ready: 'A fazer',
  inProgress: 'Em andamento',
  validation: 'Em validação',
  done: 'Concluída',
  cancelled: 'Cancelada',
};

export const labelToneClass: Record<PortalLabelTone, string> = {
  amber: 'bg-amber-300 text-amber-950',
  sky: 'bg-sky-300 text-sky-950',
  orange: 'bg-orange-300 text-orange-950',
  violet: 'bg-violet-300 text-violet-950',
};

export const activeSprintColumns: { title: string; statuses: PortalBacklogStatus[] }[] = [
  { title: 'A fazer', statuses: ['idea', 'ready'] },
  { title: 'Em andamento', statuses: ['inProgress'] },
  { title: 'Em validação', statuses: ['validation'] },
  { title: 'Concluído', statuses: ['done'] },
];

export const roadmapStatusLabel: Record<PortalRoadmapStatus, string> = {
  planned: 'Planejado',
  inProgress: 'Em andamento',
  achieved: 'Concluído',
  missed: 'Perdido',
  cancelled: 'Cancelado',
};

export const roadmapKindLabel: Record<PortalRoadmapKind, string> = {
  phase: 'Fase',
  milestone: 'Marco',
  checkpoint: 'Checkpoint',
  release: 'Release',
};

export function formatPortalDate(isoDate: string): string {
  const [year, month, day] = isoDate.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatPortalLongDate(date: Date): string {
  return date.toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export const commitmentLabel = {
  confirmed: 'Confirmada',
  planned: 'Planejada',
} as const;

export function parsePortalDate(isoDate: string): Date {
  const [year, month, day] = isoDate.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function formatPortalMonthYear(date: Date): string {
  const label = date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function formatPortalSpan(startIso: string, endIso: string, padded = false): string {
  const start = parsePortalDate(startIso);
  const end = parsePortalDate(endIso);
  const startMonth = start.toLocaleDateString('pt-BR', { month: 'short' }).replace('.', '');
  const endMonth = end.toLocaleDateString('pt-BR', { month: 'short' }).replace('.', '');
  const day = (value: number) => (padded ? String(value).padStart(2, '0') : String(value));
  if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
    return `${day(start.getDate())}–${day(end.getDate())} ${endMonth}`;
  }
  return `${day(start.getDate())} ${startMonth}–${day(end.getDate())} ${endMonth}`;
}

export function formatPortalDayMonth(isoDate: string): string {
  const [year, month, day] = isoDate.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day)
    .toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' })
    .replace('.', '')
    .replace(' de ', ' ');
}

export function formatPortalDateTime(isoDate: string): string {
  return new Date(isoDate).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function statusPillClass(status: PortalBacklogStatus | PortalRoadmapStatus): string {
  if (status === 'done' || status === 'achieved') {
    return 'bg-emerald-50 text-emerald-800';
  }
  if (status === 'inProgress') {
    return 'bg-primary-50 text-primary-800';
  }
  if (status === 'validation') {
    return 'bg-violet-50 text-violet-800';
  }
  if (status === 'missed' || status === 'cancelled') {
    return 'bg-red-50 text-red-800';
  }
  return 'bg-secondary-100 text-secondary-700';
}
